import { type CountryDto, countriesApi } from "client/api-v2";

export const getCountries = async (signal: AbortSignal): Promise<CountryDto[]> =>
  (await countriesApi.getV2Countries({ signal })).data;
